module.exports = __webpack_public_path__ + "img/IMG_9543_L_Foamcore_MockedUp.9baee224.jpg";